import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'

export function MobileNavBar ({ children }: { children: React.ReactNode }) {
  const [isScrolled, setIsScrolled] = useState(false)

  const scrollTriggerRef = useRef<HTMLDivElement>(null)
  const navbarRef = useRef<HTMLDivElement>(null)

  // Tracks whether the page is scrolled so we can add a border to the navbar
  useEffect(() => {
    if (scrollTriggerRef.current) {
      const intersectionObserver = new IntersectionObserver((entries) => {
        setIsScrolled(!entries[0].isIntersecting)
      })

      intersectionObserver.observe(scrollTriggerRef.current)

      return () => {
        intersectionObserver.disconnect()
      }
    }
  }, [])

  // Synchronizes the `scroll-padding-top` on the document element with the height
  // of the navbar so that `scrollIntoView` accounts for the sticky navbar.
  useEffect(() => {
    if (navbarRef.current) {
      const resizeObserver = new ResizeObserver(([entry]) => {
        document.documentElement.style.scrollPaddingTop = `${entry.borderBoxSize[0].blockSize + 16}px`
      })

      resizeObserver.observe(navbarRef.current)

      return () => {
        resizeObserver.disconnect()
      }
    }
  }, [])

  return (
    <>
      <div ref={scrollTriggerRef} />
      <div
        className={clsx('border-b bg-white py-2 px-4 sticky top-0 z-10 flex items-center justify-between gap-4 transition', {
          'border-gray-200': isScrolled,
          'border-transparent': !isScrolled,
        })}
        ref={navbarRef}
      >
        {children}
      </div>
    </>
  )
}
